import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import Select from 'react-select';
import ptBR from "date-fns/locale/pt-BR";

import { Alert, Box, CircularProgress, createTheme, FormControl, InputLabel, Modal, Snackbar, ThemeProvider } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { logout } from "../../state/slices/userSlice";
import { setCurrentAnaliseProjeto } from "../../state/slices/analisesSlice";
import { newTab, setTabFromNewIndex } from "../../state/slices/tabsSlice";

import servAnaliseProjeto from "../../services/login/servAnaliseProjeto";
import servFileIni from "../../services/login/servFileIni";
import servParam from "../../services/login/servParam";

import { ErrorHandling } from "../../components/Errors/Errors";
import { WhiteInput } from "../../components/Inputs/InputText";
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";
import { style as modalStyle } from "../../components/Loading/Loading";
import { SearchFieldStyles } from "../../components/Searchfields/SearchFieldStyles";
import { SearchFieldStylesFiltro } from "../../components/Searchfields/SearchFieldStylesFiltro";
import { Popup } from "../../components/Popup/Popup";
import { PopupExtraG } from "../../components/Popup/PopupExtraG";
import Lista from "../../components/Lista";

import { OpcoesPeriodoDatas } from '../../components/Combobox/PeriodoDatas';
import { OpcoesSituacaoAnaliseProjeto } from "../../components/Combobox/SituacaoAnaliseProjeto";

import { retornaDatasCfeTipoPeriodo } from "../../infra/utils/RetornaDatasCfeTipoPeriodo";

import { columnsAnaliseProjeto } from "./Lista";
import Cadastro from "./Cadastro";
import Analise from "./Analise";
import ArquivarAnaliseProjeto from "./Arquivar";

import "./style.css";
import ArquivamentoSolic from "./ArquivamentoSolic";

const AnaliseProjeto = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const user = useSelector(state => state.user);

    const [filtro, setFiltro] = useState("");
    const [filtroCodigo, setFiltroCodigo] = useState("");
    const [situacaoAnaliseProjeto, setSituacaoAnaliseProjeto] = useState([]);
    const [tipoPeriodo, setTipoPeriodo] = useState({ value: 8, label: 'Este mês' });
    const [tipoDataFiltro, setTipoDataFiltro] = useState("data-cadastro");
    const [dataInicialFiltro, setDataInicialFiltro] = useState(new Date());
    const [dataFinalFiltro, setDataFinalFiltro] = useState(new Date());

    const [analises, setAnalises] = useState([]);
    const [recordForEdit, setRecordForEdit] = useState(null);

    const [openCadastro, setOpenCadastro] = useState(false);
    const [podeVisualizarArquivamento, setPodeVisualizarArquivamento] = useState(false);
    const [openAnalise, setOpenAnalise] = useState(false);
    const [openArquivamento, setOpenArquivamento] = useState(false);

    const [eNovoCadastro, setENovoCadastro] = useState(false);
    const [podeEnviarAnalise, setPodeEnviarAnalise] = useState(false);
    const [podeSolicitarArquivamento, setPodeSolicitarArquivamento] = useState(false);
    const [tabResultadoAnalise, setTabResultadoAnalise] = useState(false);
    const [openVisualizarArquivamento, setOpenVisualizarArquivamento] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [openError, setOpenError] = useState(false);

    const theme = createTheme({
        components: {
            MuiIconButton: {
                styleOverrides: {
                    sizeMedium: {
                        color: "#d2d4d4"
                    }
                }
            }
        }
    });

    useEffect(() => {
        const recuperarDados = async (filtroDatas) => {
            try {
                setIsLoading(true);

                let dados;

                // Se não tiver situação ou data informada, faz o listar básico, só com a pesquisa geral
                if (!filtroDatas) {
                    dados = await servAnaliseProjeto.listarCFiltros(user.codigoUsuario, "");
                } else {
                    let arraySituacoes = [];

                    arraySituacoes = situacaoAnaliseProjeto.map((item) => item.value);

                    dados = await servAnaliseProjeto.listarCfeSituacaoOuData(user.codigoUsuario,
                        filtro,
                        filtroCodigo,
                        arraySituacoes,
                        tipoDataFiltro,
                        filtroDatas.dataInicial,
                        filtroDatas.dataFinal);
                }

                let content = dados?.Content;

                if (dados.Content.length === 0) {
                    return setIsLoading(false);
                }

                content && content.map((analise) => {
                    return analise.id = analise.Id
                });

                setAnalises(content);

                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);

                return ErrorHandling(
                    err?.response?.status,
                    err?.Message,
                    setOpenError,
                    setErrorMessage,
                    dispatch,
                    logout,
                    navigate,
                    err?.response?.data?.Message
                );
            }
        }

        const recuperarUltimoTipoPeriodoDefinido = async () => {
            try {
                setIsLoading(true);

                let dto = {
                    CodigoUsuario: user.codigoUsuario.toString(),
                    CodigoSecao: "TIPO_PERIODO_P3",
                    Chave: "IDTIPOPERIODOANALISEPROJETO",
                    Conteudo: ""
                };

                let response = await servFileIni.Recuperar(dto);
                let novasDatas;

                if (response.Content.trim() !== "") {
                    let conteudo = Number(response.Content);
                    let labelTipoPeriodo = OpcoesPeriodoDatas.find((periodo) => periodo.value === conteudo).label;

                    await setarTipoPeriodoERedefinirDatas({ value: conteudo, label: labelTipoPeriodo });
                    novasDatas = retornaDatasCfeTipoPeriodo(conteudo);
                } else {
                    await setarTipoPeriodoERedefinirDatas({ value: 8, label: "Este mês" });
                    novasDatas = retornaDatasCfeTipoPeriodo(8); // 8 - Este mês
                }

                if (analises.length === 0) {
                    recuperarDados(novasDatas);
                }

                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);

                return ErrorHandling(
                    err?.response?.status,
                    err?.Message,
                    setOpenError,
                    setErrorMessage,
                    dispatch,
                    logout,
                    navigate,
                    err?.response?.data?.Message
                );
            }
        }

        recuperarUltimoTipoPeriodoDefinido();
    }, []);

    useEffect(() => {
        if (recordForEdit === null) {
            setPodeEnviarAnalise(false);
            setPodeVisualizarArquivamento(false);
            setPodeSolicitarArquivamento(false);
            return;
        }

        let situacao = recordForEdit?.Situacao || (recordForEdit?.row?.Situacao ?? 0);

        const situacaoPodeEnviarAnalise = [0, 5];
        const situacaoArquivada = [6];

        situacaoPodeEnviarAnalise.includes(situacao) ? setPodeEnviarAnalise(true) : setPodeEnviarAnalise(false);
        situacaoArquivada.includes(situacao) ? setPodeVisualizarArquivamento(true) : setPodeVisualizarArquivamento(false);
        situacaoArquivada.includes(situacao) ? setPodeSolicitarArquivamento(false) : setPodeSolicitarArquivamento(true);
    }, [recordForEdit]);

    const solicitarAnalise = async () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro");
            return setOpenError(true);
        }

        const situacoesHomologaveis = [0, 5];

        if (!situacoesHomologaveis.includes(recordForEdit?.row?.Situacao)
            && !situacoesHomologaveis.includes(recordForEdit?.Situacao)) {
            setErrorMessage("Só é possível solicitar análise de análises com situação em digitação ou revisão");
            return setOpenError(true);
        }

        try {
            setIsLoading(true);

            const id = recordForEdit?.row?.Id || recordForEdit?.Id;
            const codigoTipoProjeto = recordForEdit?.row?.ConsultaPrevia?.TipoProjeto?.Id || recordForEdit?.ConsultaPrevia?.TipoProjeto?.Id;

            const [resDocsObrig, resDocsVinculados] = await Promise.all([
                servParam.RecuperarDocumentosObrigatorios(15),
                servAnaliseProjeto.listarDocumentosPorAnaliseProjeto(id)
            ]);

            const docsObrigatorios = resDocsObrig.Content ?? [];
            const docsVinculados = resDocsVinculados?.Content ?? [];

            // Calcula obrigatorioTipoProjeto para cada doc, igual ao mapearDocsComObrigatoriedade do Cadastro.jsx
            const docsComObrigatoriedadeAjustada = docsObrigatorios.map((doc) => {
                // Mantém o valor original de Obrigatorio
                const docAtualizado = { ...doc };

                // Verifica se o tipo de projeto atual torna o documento aplicável
                let obrigatorioTipoProjeto = false;

                if (doc.Obrigatorio === 2 && doc.ConfigDocsTipoProjetos && Array.isArray(doc.ConfigDocsTipoProjetos)) {
                    if (doc.ConfigDocsTipoProjetos.length === 0) {
                        obrigatorioTipoProjeto = true;
                    } else if (codigoTipoProjeto) {
                        obrigatorioTipoProjeto = doc.ConfigDocsTipoProjetos.some(
                            (item) => item.CodigoTipoProjeto === codigoTipoProjeto
                        );
                    }
                }

                docAtualizado.ObrigatorioTipoProjeto = obrigatorioTipoProjeto;
                return docAtualizado;
            });

            // Valida documentos faltando usando a mesma lógica do validarDocumentosObrigatorios do Cadastro.jsx
            const docsFaltando = docsComObrigatoriedadeAjustada.filter((doc) => {
                const docVinculado = docsVinculados.find(
                    (dv) =>
                        dv.CodigoConfigDoc == doc.Id &&
                        dv.CodigoClassificacaoDoc == doc.CodigoClassificacaoDoc
                );
                const anexado = !!docVinculado?.CodigoDocumento;

                // Obrigatório fixo (valor 1)
                if (doc.Obrigatorio === 1) {
                    return !anexado;
                }

                // Obrigatório por critério (valor 2) — valida se aplica ao tipo de projeto
                if (doc.Obrigatorio === 2 && doc.ObrigatorioTipoProjeto) {
                    return !anexado;
                }

                return false;
            });

            if (docsFaltando.length > 0) {
                const nomes = docsFaltando.map((d) => `• ${d.Descricao}`).join("\n");
                setErrorMessage(`Os seguintes documentos obrigatórios não foram anexados:\n${nomes}`);
                return setOpenError(true);
            }

            setOpenAnalise(true);
        } catch (err) {
            ErrorHandling(
                err?.response?.status,
                err?.Message,
                setOpenError,
                setErrorMessage,
                dispatch,
                logout,
                navigate,
                err?.response?.data?.Message
            );
        } finally {
            setIsLoading(false);
        }
    }

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenError(false);
        }

        setOpenError(false);
    }

    const solicitarArquivamento = async () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro")
            return setOpenError(true);
        }

        const situacoesAquivaveis = [0, 1, 2, 3, 5];

        if (situacoesAquivaveis.includes(recordForEdit?.row?.Situacao)
            || situacoesAquivaveis.includes(recordForEdit?.Situacao)) {
            return setOpenArquivamento(true);
        }

        setErrorMessage("Não é possível arquivar solicitações já aprovadas ou arquivadas.");
        return setOpenError(true);
    }

    const visualizarArquivamento = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro")
            return setOpenError(true);
        }

        return setOpenVisualizarArquivamento(true);
    }

    const onClickAbrirAnalisesAntigas = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro");
            return setOpenError(true);
        }

        const situacaoSemAnalise = 0;

        if (recordForEdit?.row?.Situacao === situacaoSemAnalise
            || recordForEdit?.Situacao === situacaoSemAnalise) {
            setErrorMessage("A solicitação ainda não foi enviada para análise, portanto não possui análises realizadas");
            return setOpenError(true);
        }

        const listaAnaliseProjeto = {
            Nome: "Análises da análise de projeto",
            Aba: 20
        }

        let id = recordForEdit?.row?.Id || recordForEdit?.Id;

        dispatch(newTab(listaAnaliseProjeto));
        dispatch(setTabFromNewIndex(listaAnaliseProjeto.Aba));
        dispatch(setCurrentAnaliseProjeto(id));

    }

    const onClickPesquisar = async () => {
        try {
            setIsLoading(true);
            let dados;

            if (situacaoAnaliseProjeto.length === 0 &&
                (!dataInicialFiltro || dataInicialFiltro.toLocaleDateString() === "") &&
                (!dataFinalFiltro || dataFinalFiltro.toLocaleDateString() === "")) {
                dados = await servAnaliseProjeto.listarCFiltros(user.codigoUsuario, filtro);
            } else {
                let arraySituacoes = [];

                arraySituacoes = situacaoAnaliseProjeto.map((item) => item.value);

                dados = await servAnaliseProjeto.listarCfeSituacaoOuData(user.codigoUsuario,
                    filtro,
                    filtroCodigo,
                    arraySituacoes,
                    tipoDataFiltro,
                    dataInicialFiltro,
                    dataFinalFiltro);
            }

            let content = dados?.Content;

            content && content.map((analises) => {
                return analises.id = analises.Id
            });

            setIsLoading(false);

            setAnalises(content);

            if (content.length === 0) {
                setErrorMessage("Não foram encontrados registros para sua pesquisa");
                setOpenError(true);
            }
        } catch (err) {
            setIsLoading(false);

            return ErrorHandling(
                err?.response?.status,
                err?.Message,
                setOpenError,
                setErrorMessage,
                dispatch,
                logout,
                navigate,
                err?.response?.data?.Message);
        }
    }

    const handleTipoDataFiltro = (event) => {
        event.preventDefault();

        setTipoDataFiltro(event.target.value)
    }

    const setarTipoPeriodoERedefinirDatas = async (tipoPeriodo) => {
        try {
            setTipoPeriodo(tipoPeriodo);

            let datasCalculadas = retornaDatasCfeTipoPeriodo(tipoPeriodo?.value);
            setDataInicialFiltro(datasCalculadas.dataInicial);
            setDataFinalFiltro(datasCalculadas.dataFinal);

            let dto = {
                Chave: "IDTIPOPERIODOANALISEPROJETO",
                Conteudo: tipoPeriodo.value.toString(),
                CodigoSecao: "TIPO_PERIODO_P3",
                CodigoUsuario: user.codigoUsuario.toString()
            };

            await servFileIni.Inserir(dto);
        } catch (err) {
            setIsLoading(false);
            setErrorMessage("Erro ao salvar tipo de período. Tente novamente.");
            setOpenError(true);
            return;
        }
    }

    const adicionarNovaAnaliseProjeto = () => {
        setENovoCadastro(true);
        setOpenCadastro(true);
    }

    const abrirAnaliseProjetoExistente = () => {
        setENovoCadastro(false);
        setOpenCadastro(true);
        setTabResultadoAnalise(false)
    }

    const abrirAnaliseAnaliseProjeto = async () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro");
            return setOpenError(true);
        }

        const situacaoSemAnalise = 0;

        if (recordForEdit?.row?.Situacao === situacaoSemAnalise
            || recordForEdit?.Situacao === situacaoSemAnalise) {
            setErrorMessage("A solicitação ainda não foi enviada para análise, portanto não possui análises realizadas");
            return setOpenError(true);
        }

        setIsLoading(true);

        setENovoCadastro(false);
        setOpenCadastro(true);
        setTabResultadoAnalise(true)

        setIsLoading(false);

        setIsLoading(false);
    }

    return (
        <div className="analiseprojeto-container">
            <div className="analiseprojetoFiltros">
                <FormControl>
                    <InputLabel shrink style={{ color: "#B8B8B8", marginLeft: "10px" }} >Pesquisa geral<FontAwesomeIcon style={{ marginLeft: "10px", width: "15px", height: "15px", cursor: "pointer" }} icon={faQuestionCircle} /></InputLabel>
                    <WhiteInput value={filtro} onChange={(e) => setFiltro(e.target.value)} placeholder="Pesquisa" id="pesquisa-nome" sx={{ width: "500px", margin: '0px 18px' }} />
                </FormControl>
            </div>
            <div className="analiseprojetoFiltros" style={{ marginTop: "20px" }}>
                <FormControl>
                    <InputLabel shrink style={{ color: "#B8B8B8", marginLeft: "10px" }} >Código</InputLabel>
                    <WhiteInput value={filtroCodigo} onChange={(e) => setFiltroCodigo(e.target.value)} placeholder="Código" id="pesquisa-codigo" sx={{ width: "200px", margin: '0px 18px' }} />
                </FormControl>
                <FormControl variant="outlined" sx={{ width: "450px", marginRight: "20px" }}>
                    <InputLabel htmlFor="pesquisa-nome-situacao" shrink style={{ color: "#B8B8B8" }}>
                        Situação
                    </InputLabel>
                    <Select
                        isMulti={true}
                        value={situacaoAnaliseProjeto}
                        onChange={value => setSituacaoAnaliseProjeto(value)}
                        options={OpcoesSituacaoAnaliseProjeto}
                        styles={SearchFieldStyles}
                        placeholder="Situação"
                    />
                </FormControl>
            </div>
            <div className="analiseprojetoFiltros">
                <FormControl variant="outlined">
                    <InputLabel htmlFor="data-analiseprojeto" shrink style={{ color: "#B8B8B8", marginTop: "20px", marginLeft: "10px" }} >
                        <select className="tipoDataFiltroAnaliseProjeto" name="tipo-data" id="tipo-data" value={tipoDataFiltro} onChange={handleTipoDataFiltro}>
                            <optgroup>
                                <option value="data-cadastro" selected>Data cadastro</option>
                            </optgroup>
                        </select>
                    </InputLabel>
                    <div className="analiseprojetoDatas">
                        <Select
                            value={tipoPeriodo}
                            onChange={(e) => setarTipoPeriodoERedefinirDatas(e)}
                            options={OpcoesPeriodoDatas}
                            styles={SearchFieldStylesFiltro}
                            placeholder="Período"
                        />
                        <ThemeProvider theme={theme}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={{ todayButtonLabel: "Hoje" }}>
                                <DatePicker
                                    fullWidth
                                    inputFormat="dd/MM/yyyy"
                                    value={dataInicialFiltro}
                                    onChange={(e) => setDataInicialFiltro(e)}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{ color: "#707070" }} />
                                            <span style={{ position: "absolute", top: 58, right: 250, color: "white", svg: "white", input: "white", label: "white" }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                    componentsProps={{
                                        actionBar: {
                                            actions: ["today"]
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </ThemeProvider>
                        <span style={{ color: "whitesmoke", margin: "9px 5px" }}>-</span>
                        <ThemeProvider theme={theme}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={{ todayButtonLabel: "Hoje" }}>
                                <DatePicker
                                    fullWidth
                                    inputFormat="dd/MM/yyyy"
                                    value={dataFinalFiltro}
                                    onChange={(e) => setDataFinalFiltro(e)}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{ color: "#707070" }} />
                                            <span style={{ position: "absolute", top: 58, right: 30, color: "white", svg: "white", input: "white", label: "white" }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                    componentsProps={{
                                        actionBar: {
                                            actions: ["today"]
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </ThemeProvider>
                    </div>
                </FormControl>
                <BlueHoverButton variant="contained" onClick={onClickPesquisar} style={{ marginTop: "16.5px" }}>
                    Pesquisar
                </BlueHoverButton>
            </div>
            <div className="analiseprojeto-botoes">
                <BlueHoverButton variant="contained" onClick={adicionarNovaAnaliseProjeto}>Nova análise de projeto</BlueHoverButton>
                {podeEnviarAnalise && (
                    <BlueHoverButton variant="contained" onClick={solicitarAnalise}>Enviar para análise</BlueHoverButton>
                )}
                <BlueHoverButton variant="contained" onClick={abrirAnaliseAnaliseProjeto}>Resultado análise</BlueHoverButton>
                <BlueHoverButton variant="contained" onClick={onClickAbrirAnalisesAntigas}>Resultados anteriores</BlueHoverButton>
                {podeSolicitarArquivamento && (
                    <BlueHoverButton variant="contained" onClick={solicitarArquivamento}>Arquivar</BlueHoverButton>
                )}
                {podeVisualizarArquivamento && (
                    <BlueHoverButton variant="contained" onClick={visualizarArquivamento}>Arquivamento</BlueHoverButton>
                )}
            </div>
            <div className="analiseprojeto-lista" style={{ height: '510px' }}>
                <Modal open={isLoading}>
                    <Box style={modalStyle}>
                        <CircularProgress color="inherit" />
                    </Box>
                </Modal>
                <Lista
                    columns={columnsAnaliseProjeto}
                    rows={analises}
                    onDblClick={abrirAnaliseProjetoExistente}
                    setSelectedData={setRecordForEdit}
                    hideFooter={false}
                    autoHeight={false}
                />
                <PopupExtraG title="Análise de projeto" openPopup={openCadastro} setOpenPopup={setOpenCadastro} novoCadastro={eNovoCadastro} setNovoCadastro={setENovoCadastro}>
                    <Cadastro
                        pesquisar={onClickPesquisar}
                        recordForEdit={recordForEdit}
                        setRecordForEdit={setRecordForEdit}
                        setOpen={setOpenCadastro}
                        novoCadastro={eNovoCadastro}
                        setEhNovoCadastro={setENovoCadastro}
                        tabResultadoAnalise={tabResultadoAnalise}
                        key={"AnaliseProjeto"}
                    />
                </PopupExtraG>

                <Popup title="Enviar para análise" openPopup={openAnalise} setOpenPopup={setOpenAnalise} minHeight="100px" >
                    <Analise
                        pesquisar={onClickPesquisar}
                        record={recordForEdit}
                        setOpen={setOpenAnalise}
                    />
                </Popup>

                <Popup title="Arquivar análise de projeto" openPopup={openArquivamento} setOpenPopup={setOpenArquivamento} minHeight="100px">
                    <ArquivarAnaliseProjeto
                        pesquisar={onClickPesquisar}
                        recordForEdit={recordForEdit}
                        setOpenPopup={setOpenArquivamento}
                    />
                </Popup>

                <Popup title="Arquivamento" openPopup={openVisualizarArquivamento} setOpenPopup={setOpenVisualizarArquivamento} minHeight="100px">
                    <ArquivamentoSolic
                        setOpenPopup={setOpenVisualizarArquivamento}
                        recordForEdit={recordForEdit}
                        pesquisar={onClickPesquisar}
                    />
                </Popup>

                <Modal open={isLoading} >
                    <Box style={modalStyle} >
                        <CircularProgress color="inherit" />
                    </Box>
                </Modal>

                <Snackbar open={openError} anchorOrigin={{ vertical: "top", horizontal: "center" }} autoHideDuration={6000} onClose={handleCloseError}>
                    <Alert onClose={handleCloseError} severity="error" sx={{ width: "100%" }}>
                        {errorMessage}
                    </Alert>
                </Snackbar>
            </div>
        </div>
    )
}

export { AnaliseProjeto };